/**
 * scaleOffer.js — s126 (Dr. Rami 2026-10-31; canvas "Orella Diagnostic Scales" A1; copy claude/ORELLA_SCALES_COPY_v1.md
 * APPROVED). Which free validated scale Detect offers, if any.
 *
 * His rulings: the HIGHEST-RANKED diagnosis whose likelihood is High AND that has a mapped scale gets ONE scale; a
 * Moderate or Low diagnosis never triggers one; only free scales are asked in the app (data/scales.json — NLHQ, TNSS).
 * The differential is the patient's written summary (currentCase.patientSummary.differentialDx, s107: the same list the
 * clinician sees). A diagnosis maps by a name phrase (whole words, lower case) or an ICD-10 code prefix. Pure module.
 */
const norm = (s) => ` ${String(s || '').toLowerCase().replace(/[^a-z0-9.]+/g, ' ').trim()} `

export function scaleForDiagnosis(dx, map) {
  if (!dx || typeof dx !== 'object') return null
  const name = norm(dx.diagnosis || dx.condition)
  const code = String(dx.icdCode || '').toUpperCase().trim()
  for (const row of Array.isArray(map) ? map : []) {
    if ((row.names || []).some((n) => name.includes(norm(n)))) return row
    if (code && (row.icd || []).some((c) => code.startsWith(String(c).toUpperCase()))) return row
  }
  return null
}

export function pickScaleOffer(differential, library) {
  const scales = (library && library.scales) || {}
  for (const dx of Array.isArray(differential) ? differential : []) {
    if (String(dx?.likelihood || '').trim().toLowerCase() !== 'high') continue
    const row = scaleForDiagnosis(dx, library && library.map)
    if (row && scales[row.scale]) return { scale: scales[row.scale], dx: dx.diagnosis || dx.condition || '', dueWeeks: row.dueWeeks }
  }
  return null
}

/** The saved Detect scale rows of a case (server detect_data.patientScales, or the local copy). */
export function savedPatientScales(c) {
  const rows = c?.detectData?.patientScales || c?.detect_data?.patientScales || c?.patientScales
  return Array.isArray(rows) ? rows : []
}

/** es lookup for the scale texts (data/scales.json `es`); English stays English. */
export const scaleText = (library, language) => (s) => (language === 'es' && library?.es?.[s]) || s
